import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const CURRENCY = "USD";

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [form, setForm] = useState({
    email: "",
    countryCode: "",
    firstName: "",
    lastName: "",
    company: "",
    address: "",
    address2: "",
    city: "",
    postalCode: "",
  });
  const [errors, setErrors] = useState({});

  const getProductById = (id) =>
    productData.find((product) => product.id === id);

  const cartProducts = cartItems
    .map((item) => ({ item, product: getProductById(item.id) }))
    .filter(({ product }) => product);

  const calculateTotal = () =>
    cartProducts.reduce((total, { item, product }) => {
      const price = Number.parseFloat(String(product.price).replace(/,/g, ""));
      return total + (Number.isFinite(price) ? price * item.quantity : 0);
    }, 0);

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const createOrderNo = () => {
    const randomValues = new Uint32Array(2);
    window.crypto.getRandomValues(randomValues);
    return `${Date.now()}${randomValues[0]}${randomValues[1]}`;
  };

  const handlePayNow = (event) => {
    event.preventDefault();

    const requiredFields = [
      "email",
      "countryCode",
      "firstName",
      "lastName",
      "address",
      "city",
      "postalCode",
    ];
    const nextErrors = requiredFields.reduce((result, field) => {
      if (!form[field].trim()) result[field] = "This field is required";
      return result;
    }, {});

    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      nextErrors.email = "Enter a valid email address";
    }
    if (cartProducts.length === 0 || calculateTotal() <= 0) {
      nextErrors.cart = "Your cart is empty";
    }
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    const origin = window.location.origin;
    const params = new URLSearchParams({
      orderNo: createOrderNo(),
      amount: calculateTotal().toFixed(2),
      currency: CURRENCY,
      email: form.email.trim(),
      success_url: new URL("/payment?state=success", origin).toString(),
      cancel_url: new URL("/payment?state=cancel", origin).toString(),
      title: cartProducts[0].product.name,
    });

    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div id="tuddlepetgoods-checkout" className="template-index theme-animate-hover">
      <div className="main-containerCheck">
        <div className="check-custom-checkout-page">
          <div className="left">
            <div className="check-order-info">
              <form onSubmit={handlePayNow} noValidate>
                <div className="form-group">
                  <label htmlFor="email">Contact</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={form.email}
                    placeholder="Email address"
                    onChange={updateField}
                    autoComplete="email"
                  />
                  {errors.email && <p className="error">{errors.email}</p>}
                </div>

                <div className="form-group">
                  <label>Delivery</label>
                  <ReactFlagsSelect
                    selected={form.countryCode}
                    onSelect={(countryCode) => {
                      setForm((current) => ({ ...current, countryCode }));
                      setErrors((current) => ({ ...current, countryCode: "" }));
                    }}
                    className={errors.countryCode ? "check-select check-select--error" : "check-select"}
                  />
                  {errors.countryCode && <p className="error">{errors.countryCode}</p>}
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input name="firstName" value={form.firstName} placeholder="First name *" onChange={updateField} autoComplete="given-name" />
                    {errors.firstName && <p className="error">{errors.firstName}</p>}
                  </div>
                  <div className="form-group">
                    <input name="lastName" value={form.lastName} placeholder="Last name *" onChange={updateField} autoComplete="family-name" />
                    {errors.lastName && <p className="error">{errors.lastName}</p>}
                  </div>
                </div>

                <div className="form-group">
                  <input name="company" value={form.company} onChange={updateField} placeholder="Company name (optional)" autoComplete="organization" />
                </div>

                <div className="form-group">
                  <input name="address" value={form.address} onChange={updateField} placeholder="Address" autoComplete="address-line1" />
                  {errors.address && <p className="error">{errors.address}</p>}
                </div>

                <div className="form-group">
                  <input name="address2" value={form.address2} onChange={updateField} placeholder="Apartment, suite, etc. (optional)" autoComplete="address-line2" />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input name="city" value={form.city} placeholder="City" onChange={updateField} autoComplete="address-level2" />
                    {errors.city && <p className="error">{errors.city}</p>}
                  </div>
                  <div className="form-group">
                    <input name="postalCode" value={form.postalCode} placeholder="Postal code" onChange={updateField} autoComplete="postal-code" />
                    {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                  </div>
                </div>

                {errors.cart && <p className="error check-cart-error">{errors.cart}</p>}
                <button type="submit" className="check-checkout-button">Pay Now</button>
              </form>

              <p>
                <Link to="/returns" style={{ textDecoration: "underline" }} onClick={toTop}>
                  Shipping &amp; Returns Info
                </Link>
              </p>
            </div>
          </div>

          <div className="right">
            <div className="check-order-summary">
              <div className="check-order-details">
                {cartProducts.map(({ item, product }, index) => (
                  <div key={`${item.id}-${item.size}-${item.color}-${index}`} className="check-cart-item">
                    <img src={product.images[0]} alt={product.name} />
                    <div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div>
                    <div className="check-item-details">
                      <h3>
                        {product.name}
                        {item.size && <><br />Size: {item.size}</>}
                        {item.color && <><br />Color: {item.color}</>}
                      </h3>
                    </div>
                    <p className="cal-single">${product.price}</p>
                  </div>
                ))}

                <div className="check-summary-details">
                  <div className="gridTotal">
                    <table className="summary-details22">
                      <tbody className="sumTbody22">
                        <tr className="sumTr22">
                          <th className="subtotalTh22" style={{ fontSize: "24px" }}>Total</th>
                          <th className="subtotalTxt22">${calculateTotal().toFixed(2)} {CURRENCY}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckOut;
